import angular from "angular";
import { pageLinkWindow } from "./data-pager-window";

angular
    .module('ui-common')
    .directive('apiDataPager', function () {
        return {
            require: '?ngModel',
            restrict: 'E',
            replace: true,

            template: require('./data-pager-template.html'),
            scope: {
                ngModel: '=',
                translations: '=',
                service: '=',
                pageLinksToDisplay: '=',
                itemsLabel: '@'
            },
            link: function ($scope, elem, attrs) {
                const visiblePages = $scope.pageLinksToDisplay ?? 10;
                let minVisibleLinkIndex;
                let maxVisibleLinkIndex;

                const update = () => {
                    const window = pageLinkWindow($scope.service.currentPage, $scope.service.maxPage, visiblePages);
                    minVisibleLinkIndex = window.min;
                    maxVisibleLinkIndex = window.max;
                }
                $scope.$watch('service.maxPage', () => {
                    update();
                });
                $scope.$watch('service.currentPage', () => {
                    update();
                });
                $scope.showPageLink = (i) => {
                    return i >= minVisibleLinkIndex && i <= maxVisibleLinkIndex;
                };
                $scope.firstPageLinkShown = () => {
                    return minVisibleLinkIndex === 0;
                };
                $scope.lastPageLinkShown = () => {
                    return maxVisibleLinkIndex === $scope.service.maxPage - 1;
                };
            }
        }
    });
